import {
  Activity,
  FileText,
  CheckCircle,
  XCircle,
} from 'lucide-react';
import { createElement } from 'react';
import { ACTION_COLORS } from '@/constants/theme';

export interface AuditLogEntry {
  id: string;
  action: string;
  userName: string | null;
  userEmail: string | null;
  entityType: string | null;
  createdAt: string;
}

export interface AuditStatsResponse {
  success: boolean;
  data: {
    total: number;
    byAction: { action: string; count: number }[];
  };
}

export function getActionColor(action: string): string {
  return ACTION_COLORS[action] || 'var(--color-primary-500)';
}

export function getActionIcon(action: string) {
  const color = getActionColor(action);
  const cn = 'h-5 w-5';
  const style = { color };
  switch (action) {
    case 'LOGIN': return createElement(Activity, { className: cn, style });
    case 'REPORT_CREATE': return createElement(FileText, { className: cn, style });
    case 'REPORT_APPROVE': return createElement(CheckCircle, { className: cn, style });
    case 'REPORT_REJECT': return createElement(XCircle, { className: cn, style });
    case 'REPORT_DELETE': return createElement(XCircle, { className: cn, style });
    default: return createElement(Activity, { className: cn, style });
  }
}

export function formatDateTime(dateStr: string, locale: string): string {
  return new Date(dateStr).toLocaleDateString(locale === 'he' ? 'he-IL' : 'en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
